import { DateTime } from "luxon"

export const formatDateDiffDisplay = (date: string, short: boolean = false): string => {
  const dateTime = DateTime.fromISO(date)
  const diff = dateTime.diffNow(["days", "hours", "minutes"]).negate()

  if (diff.days >= 7) {
    const weeks = Math.floor(diff.days / 7)
    return short ? `${weeks}w ago` : `${weeks} week${weeks > 1 ? "s" : ""} ago`
  }
  if (diff.days >= 1) {
    const days = Math.floor(diff.days)
    return short ? `${days}d ago` : `${days} day${days > 1 ? "s" : ""} ago`
  }
  if (diff.hours >= 1) {
    const hours = Math.floor(diff.hours)
    return short ? `${hours}h ago` : `${hours} hour${hours > 1 ? "s" : ""} ago`
  }
  if (diff.minutes >= 1) {
    const minutes = Math.floor(diff.minutes)
    return short ? `${minutes}m ago` : `${minutes} minute${minutes > 1 ? "s" : ""} ago`
  }

  return "Just now"
}
